function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();

if(window.location.href.includes('?page=')){
window.location.replace(window.location.href.split('?')[0]);
}
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        pagination_click_fun(); // reinit click event
      }
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}



// faq tabs toggal start

      function togal_tabs (item) {
        item.addEventListener("click", () => {
           toggal_all_tabs(item.getAttribute('data-faq_content'));
        });        
      }
        function toggal_all_tabs(tabs_data){
                let tabs_button = document.querySelectorAll("[data-faq_content]");
                            tabs_button.forEach(b => {
                              if(b.getAttribute('data-faq_content') == tabs_data){
                                if(b.classList.contains('is_open')){
                                   b.classList.remove("is_open");    
                                  }else{
                                   b.classList.add("is_open");
                                  }
                              }else{
                                 b.classList.remove("is_open");
                              }
                              });
                           
              }
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
      tabs_title.forEach(togal_tabs);
}
      faq_taggol();


// faq tabs toggal end


     // Add this code make menu appears image hover
      function bindMouseOverToMegaMenu_images (item) {
        item.addEventListener("mouseover", () => {
           image_hide(item.getAttribute('data-image-name'));
          let image = document.querySelector(".header__inline-menu").querySelector("img.col_image")
          item.addEventListener("mouseleave", () => {
            image_hide();
          });
        });
      }
        function image_hide(imag){
             let images_val = document.querySelector(".header__inline-menu").querySelectorAll("img.col_image");
              images_val.forEach(b => {
              if(b.alt == imag){
                b.classList.remove("hidden");
              }else{
                b.classList.add("hidden");
              }
                });
          }
      let images = document.querySelector(".header__inline-menu").querySelectorAll("[data-image-name]");
      images.forEach(bindMouseOverToMegaMenu_images);


// recantely product script
    window.theme = window.theme || {};
theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};


theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');
    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
//end 



//  Accordion JS Code Start

 $(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.acc_title_cls');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
  
  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');
    if(document.body.classList.contains('product')){
      console.log(this.offsetHeight);
      window.scrollTo(0,1000);
    }
    if (!e.data.multiple) {
      $el.find('.acc_content_cls').not($next).slideUp().parent().removeClass('open');
    };
  } 

  var accordion = new Accordion($('#accordion'), false);

   
  var Accordion_pdp = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.acc_title_cls');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
  
  Accordion_pdp.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');
    if(document.body.classList.contains('product')){
      window.scrollTo(0,1200);
    }
    if (!e.data.multiple) {
      $el.find('.acc_content_cls').not($next).slideUp().parent().removeClass('open');
    };
  } 

  var accordion = new Accordion_pdp($('#accordion_pdp'), false);

      if(window.location.search == ('?create_customer')){
           $(".success-msg-modal").addClass('model-open');
           window.history.replaceState('', '', window.location.href.split('?')[0]);
      }
    $(".close-btn, .bg-overlay").click(function(){
    $(".success-msg-modal").removeClass('model-open');
  });


   
});